<div class="m-wrapper">
    <span multilang class="m-title ellipsis">{{title}}</span>
    <span multilang>
        <button mat-dialog-close mat-icon-button>
            <mat-icon>close</mat-icon>
        </button>
    </span>
</div>
<mat-divider></mat-divider>
<div class="map-wrapper">
    <div id="map" class="map-body">
    </div>
</div>